// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__JUH7e","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3XUtR","gfeWrapper":"CalendarEvent_gfeWrapper__1LxUm"};